import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getEmployeeCountText } from '../../../../shared/util/companyReport';
import BarChart from '../../components/graphs/barChart/BarChart';
import CircleGraph from '../../components/graphs/circleGraph/CircleGraph';

function Demographics({ data, coData, onOpenModal, graphLimit }) {
  const { t } = useTranslation();

  const { ages, have_children, home_office, night_shift } = data;
  const { ages_counter, have_children_counter, home_office_counter, night_shift_counter } = coData;
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const age = [
    {
      date: '16-24',
      value: Math.round((100 / ages_counter) * ages[0]),
    },
    {
      date: '25-34',
      value: Math.round((100 / ages_counter) * ages[1]),
    },
    {
      date: '35-44',
      value: Math.round((100 / ages_counter) * ages[2]),
    },
    {
      date: '45-54',
      value: Math.round((100 / ages_counter) * ages[3]),
    },
    {
      date: '55-64',
      value: Math.round((100 / ages_counter) * ages[4]),
    },
    {
      date: '65+',
      value: Math.round((100 / ages_counter) * ages[5]),
    },
  ];

  return (
    <>
      <BarChart
        preText={getEmployeeCountText(ages_counter)}
        title={t('DM001')}
        data={age}
        unit="%"
        width="wide"
        disabled={ages_counter < graphLimit}
      />
      <CircleGraph
        preText={getEmployeeCountText(have_children_counter)}
        title={t('DM002')}
        square
        colour="colour1"
        value={have_children}
        subText=""
        large
        percent={Math.round((100 / have_children_counter) * have_children)}
        disabled={have_children_counter < graphLimit}
      />
      <CircleGraph
        preText={getEmployeeCountText(home_office_counter)}
        title={t('DM005')}
        square
        colour="colour1"
        value={home_office}
        subTitle={t('DM006')}
        large
        modalText={t('DM007')}
        percent={
          home_office_counter > 0 ? Math.round((100 / home_office_counter) * home_office) : 0
        }
        onOpenModal={onOpenModal}
        disabled={home_office_counter < graphLimit}
      />
      <CircleGraph
        preText={getEmployeeCountText(night_shift_counter)}
        title={t('DM003')}
        square
        colour="colour2"
        value={night_shift}
        large
        percent={Math.round((100 / night_shift_counter) * night_shift)}
        modalText={t('DM004')}
        onOpenModal={onOpenModal}
        disabled={night_shift_counter < graphLimit}
      />
    </>
  );
}
export default Demographics;
